import { render, staticRenderFns } from "./Modelo145Edit.vue?vue&type=template&id=2852a3f6&scoped=true&"
import script from "./Modelo145Edit.vue?vue&type=script&lang=js&"
export * from "./Modelo145Edit.vue?vue&type=script&lang=js&"
import style0 from "./Modelo145Edit.vue?vue&type=style&index=0&id=2852a3f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852a3f6",
  null
  
)

export default component.exports